import React, { useState, useEffect } from "react";
import { dataSourceService } from "../../../api/holidayProfileApi";
import { toast } from "react-toastify";
import { HolidayProfileForm } from "../../forms/Master/HolidayProfileForm";
import PropTypes from "prop-types";
import { showDeleteConfirm } from "../../common/ConfirmationModal";
import Axios from "axios";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function HolidayProfilePage({ history }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [holidayProfile, setHolidayProfile] = useState([]);
  const [rowSelected, setRowSelected] = useState({});
  const location = useLocation();
  let defaultPagination = location.state
    ? location.state.currentPage
      ? location.state.currentPage
      : 1
    : 1;
  const [currentPage, setCurrentPage] = useState(defaultPagination);

  useEffect(() => {
    const CancelToken = Axios.CancelToken;
    const source = CancelToken.source();
    dataSourceService
      .getHdrDataSource(source)
      .then((result) => {
        setIsLoading(false);
        setHolidayProfile(result);
      })
      .catch((error) => {
        showErrorMessage(t("general.fail_to_load_record") + error.message);
      });
    return () => {
      source.cancel();
    };
  }, [t]);

  function addNewItem() {
    history("/home/holiday/holidayprofile", {
      state: { currentPage: currentPage },
    });
  }

  function editItem(ProfileKey) {
    history("/home/holiday/holidayprofile/" + ProfileKey, {
      state: { currentPage: currentPage },
    });
  }

  function deleteItem(ProfileKey) {
    setIsLoading(true);
    dataSourceService
      .deleteHolidayProfile(ProfileKey)
      .then(() => {
        const newData = holidayProfile.filter(
          (item) => item.ProfileKey !== ProfileKey
        );
        setHolidayProfile(newData);
        setIsLoading(false);
        toast.success(t("general.record_deleted_successfully"));
      })
      .catch(() => {
        setIsLoading(false);
        showErrorMessage(t("holidayProfileForm.data_already_in_used"));
      });
  }

  function onDelete(ProfileKey) {
    showDeleteConfirm("Holiday Profile", ProfileKey, deleteItem, t);
  }

  function showErrorMessage(message) {
    toast.error(message);
  }

  function onRowSelected(value) {
    if (value.UpdatedDate) {
      value.UpdatedOn = value.UpdatedDate;
    }
    if (value.CreatedDate) {
      value.CreatedOn = value.CreatedDate;
    }
    setRowSelected(value);
  }

  return (
    <HolidayProfileForm
      holidayProfile={holidayProfile}
      onDelete={onDelete}
      onAdd={addNewItem}
      onEdit={editItem}
      history={history}
      isLoading={isLoading}
      onRowSelected={onRowSelected}
      rowSelected={rowSelected}
      setCurrentPage={setCurrentPage}
      currentPage={currentPage}
    />
  );
}

HolidayProfilePage.propTypes = {
  history: PropTypes.func.isRequired,
};
